<template>
  <section class="preview">
    <form novalidate @submit.prevent="crear">
      <mdb-input
        label="Nombre de rol"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el nombre"
      ></mdb-input>

      <mdb-input
        label="Objetivo"
        class="mb-3 mt-0"
        v-model="objective"
        required
        invalidFeedback="Coloca el Objetivo"
      ></mdb-input>

      <mdb-input
        label="URL de redirección"
        class="mb-3 mt-0"
        v-model="redirectUrl"
        required
        invalidFeedback="Coloca la url"
      ></mdb-input>

      <mdb-input
        label="URL directa"
        class="mb-3 mt-0"
        v-model="directUrl"
        required
        invalidFeedback="Coloca la url"
      ></mdb-input>

      <mdb-input
        label="URL traking"
        class="mb-3 mt-0"
        v-model="trakingUrl"
        required
        invalidFeedback="Coloca la url"
      ></mdb-input>

      <mdb-input
        type="number"
        label="Pago"
        class="mb-3 mt-0"
        v-model="payout"
        required
        invalidFeedback="Coloca el pago"
      ></mdb-input>

      <label>Estrategias</label>
      <multiselect
        v-model="strategyActionsSelected"
        placeholder="Estrategias de acción"
        class="mb-3"
        label="name"
        track-by="id"
        :options="strategyActions"
        :multiple="false"
      ></multiselect>

      <label>Líneas de contenido</label>
      <multiselect
        v-model="linesSelected"
        placeholder="Seleccione una linea"
        label="name"
        class="mb-3"
        track-by="id"
        :options="lines"
        :multiple="true"
      ></multiselect>

      <label>Estereotipos</label>
      <multiselect
        v-model="targeting_ids"
        placeholder="Seleccione una linea"
        label="name"
        class="mb-3"
        track-by="id"
        :options="targets"
        :multiple="true"
      ></multiselect>

      <label>Partners</label>
      <multiselect
        v-model="partner"
        placeholder="Seleccione un partner"
        label="name"
        class="mb-3"
        track-by="id"
        :options="partners"
        :multiple="false"
      ></multiselect>

      <div class="form-group">
            <label class="typo__label">País</label>
            <multiselect
            v-model="selectedCountry"
            placeholder="Seleccione el País"
            label="name"
            track-by="id"
            :options="countries"
             @select="getStates"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>

       <div class="form-group" v-if="selectedCountry.hasOwnProperty('id')">
            <label class="typo__label">Estados</label>
            <multiselect
            v-model="state_ids"
            placeholder="Seleccione el País"
            label="name"
            track-by="id"
            :options="states"
            :multiple="true"
            :taggable="false"
            ></multiselect>
        </div>

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Crear</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import Multiselect from "vue-multiselect";
import store from "../../store";
export default {
  name: "modal-2",
  components: {
    mdbInput,
    mdbBtn,
    SemipolarSpinner,
    Multiselect
  },
  props: {
    onClick: Function
  },
  data: () => {
    return {
      isLoading: false,
      name: "",
      objective: "",
      directUrl: "",
      redirectUrl: "",
      trakingUrl: "",
      payout: "",
      accounts: [],
      selectedCountry: {},
      countries: [],
      strategyActions: [],
      strategyActionsSelected: [],
      lines: [],
      linesSelected: [],
      partners: [],
      partner: {},
      states:[],
      state_ids:[],
      targets:[],
      targeting_ids:[]
    };
  },
  async mounted() {
    //var respuesta = await this.getBusinessAccounts();
    var respuesta = await this.getStrategyActions();
    respuesta = await this.getLines();
    respuesta = await this.getPartners();
    respuesta = await this.getCountries();
    respuesta = await this.getStereotypes();
  },
  methods: {
    crear(event) {
      event.target.classList.add("was-validated");
      var { name, objective, redirectUrl, trakingUrl } = this;
      this.isLoading = true;
      if (
        name == "" ||
        objective == "" ||
        redirectUrl == "" ||
        trakingUrl == ""
      ) {
        this.isLoading = false;
      } else {
        var strategic_id = this.strategyActionsSelected.id;
        var city_ids = [];
        var state_ids = []
        var lines_ids = [];
        var targeting_ids = []

        this.linesSelected.map(i => {
          lines_ids.push(i.id);
        });
        this.state_ids.map(i => {
          state_ids.push(i.id);
        });
        this.targeting_ids.map(i => {
          targeting_ids.push(i.id);
        });

        var promotion = {
          name: this.name,
          objective: this.objective,
          redirect_url: this.redirectUrl,
          direct_url: this.directUrl,
          tracking_url: this.trakingUrl,
          payout: this.payout,
          strategic_id,
          lines_ids,
          city_ids,
          state_ids,
          targeting_ids,
          partner_id: this.partner.id,
          partnerSelected: this.partner,
          country_id:this.selectedCountry.id,
          selectedCountry: this.selectedCountry,
          strategyActionsSelected:this.strategyActionsSelected,
          linesSelected:this.linesSelected,
          statesSelected: this.state_ids,
          targetsSelected: this.targeting_ids,
        };
        store.dispatch("newPromotion", promotion).then(() => {
          this.name = "";
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    async getStates(opcion){
     this.states = []
     this.state_ids= []
      var country_id = opcion.id;
      await store.dispatch("getStateCountry",country_id).then(() => {
          var states = store.getters.getStates;
          this.states= states;
        });
    },
    async getBusinessAccounts() {
      var accounts = store.getters.getBusinessAccounts;
      if (accounts.length == 0) {
        await store.dispatch("getBusinessAccounts").then(() => {
          accounts = store.getters.getBusinessAccounts;
          this.accounts = accounts;
          return;
        });
      } else {
        this.accounts = accounts;
        return;
      }
    },
    async getCountries() {
      var countries = store.getters.getCountries;
      if (countries.length == 0) {
        await store.dispatch("getCountries").then(() => {
          var countryArray =[];
          countries = store.getters.getCountries;
          countries.map(i=>{
            var retorno={
              id:i.id,
              label: i.name,
              code:i.code,
              children:null
            }
            countryArray.push(retorno)
            return i;
          })
        this.countries = countries;
          return;
        });
      } else {
         var countryArray =[];
          countries = store.getters.getCountries;
          countries.map(i=>{
            var retorno={
             id:i.id,
              label: i.name,
              code:i.code,
              children:null
            }
            countryArray.push(retorno)
            return i;
          })
        this.countries = countries;
        return;
      }
    },
    async getStrategyActions() {
      var strategyActions = store.getters.getStrategyActions;
      if (strategyActions.length == 0) {
        store.dispatch("getStrategyActions").then(() => {
          strategyActions = store.getters.getStrategyActions;
          this.strategyActions = strategyActions;
          return;
        });
      } else {
        this.strategyActions = strategyActions;
        return;
      }
    },
    async getLines() {
      var lines = store.getters.getLines;
      if (lines.length == 0) {
        await store.dispatch("getLines").then(() => {
          lines = store.getters.getLines;
          this.lines = lines;
          return;
        });
      } else {
        this.lines = lines;
        return;
      }
    },
    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          this.partners = partners;
        });
      } else {
        this.partners = partners;
      }
    },
    async getStereotypes() {
      var targets = store.getters.getStereotypes;
      if (targets.length == 0) {
        await store.dispatch("getStereotypes").then(() => {
          targets = store.getters.getStereotypes;
          this.targets = targets;
          return;
        });
      } else {
        this.targets = targets;
        return;
      }
    },
  }
};
</script>

<style scoped>
</style>